import { postApi } from 'api/fetchApi'
import { definitions } from 'api/generated/mnogocard'

export const linkCardToUserApi = (cardNumber: string) => {
  return postApi<void, definitions['MnogocardLinkCardToUserPostBodyRequest']>(
    '/mnogocard/linkCardToUser' as 'mnogocard/linkCardToUser',
    { cardNumber }
  )
}
